import React, { ComponentType } from "react";

const withInjectedProps = <P extends object, IP extends object>(injectedProps:IP) => (WrappedComponent: ComponentType<P & IP>): ComponentType<P & IP> => {
    const WithInjectedProps = (props:P) => <React.Fragment><WrappedComponent {...injectedProps} {...props} /></React.Fragment>;
    return WithInjectedProps;
};

export default withInjectedProps;
